(function () {
  'use strict';

  function parseMoneyToCents(text) {
    var match = String(text || '').replace(/\s/g, '').match(/-?\d[\d,]*(?:\.\d{1,2})?/);
    if (!match) return null;
    var value = parseFloat(match[0].replace(/,/g, ''));
    return isNaN(value) ? null : Math.round(value * 100);
  }

  function currencyPrefix(text) {
    var match = String(text || '').match(/A\$|NZ\$|US\$|\$|€|£/);
    return match ? match[0] : '$';
  }

  function formatMoneyLike(cents, sourceText) {
    var amount = cents / 100;
    var formatted;
    try {
      formatted = amount.toLocaleString('en-AU', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    } catch (e) {
      formatted = amount.toFixed(2);
    }
    return currencyPrefix(sourceText) + formatted;
  }

  function removeMainPdpIncGst() {
    var inc = document.querySelector('body.templateProduct #product-info .silverchef-price-block .ince_gst_price');
    if (inc) {
      var wrapper = inc.parentNode;
      if (wrapper && wrapper !== document.body && wrapper.children.length === 1) {
        wrapper.parentNode.removeChild(wrapper);
      } else if (inc.parentNode) {
        inc.parentNode.removeChild(inc);
      }
    }
  }

  function enhanceMainPdpPrice() {
    var detail = document.querySelector('body.templateProduct #product-info .silverchef-price-block .detail-price');
    if (!detail) return;

    var sell = detail.querySelector('.price-sale') || detail.querySelector('.price');
    var compare = detail.querySelector('.price-compare');
    var oldBreak = detail.querySelector('.ice-pdp-price-break');
    if (oldBreak && oldBreak.parentNode) oldBreak.parentNode.removeChild(oldBreak);

    if (!sell || !compare) {
      var oldRow = detail.querySelector('.ice-pdp-rrp-row');
      if (oldRow && oldRow.parentNode) oldRow.parentNode.removeChild(oldRow);
      return;
    }

    var sellCents = parseMoneyToCents(sell.textContent);
    var compareCents = parseMoneyToCents(compare.textContent);
    if (sellCents === null || compareCents === null || compareCents <= sellCents) return;

    if (!/^\s*RRP\b/i.test(compare.textContent)) {
      var rrp = document.createElement('span');
      rrp.className = 'ice-pdp-rrp-label';
      rrp.appendChild(document.createTextNode('RRP '));
      compare.insertBefore(rrp, compare.firstChild);
    }

    var row = detail.querySelector('.ice-pdp-rrp-row');
    if (!row) {
      row = document.createElement('div');
      row.className = 'ice-pdp-rrp-row';
      compare.parentNode.insertBefore(row, compare);
    }
    if (compare.parentNode !== row) {
      row.appendChild(compare);
    }

    var save = row.querySelector('.ice-pdp-save');
    if (!save) {
      save = document.createElement('span');
      save.className = 'ice-pdp-save';
      row.appendChild(save);
    }

    var saveText = 'SAVE ' + formatMoneyLike(compareCents - sellCents, compare.textContent);
    if (save.textContent !== saveText) {
      save.textContent = saveText;
    }
  }

  function init() {
    if (!document.body || !document.body.classList.contains('templateProduct')) return;

    removeMainPdpIncGst();
    enhanceMainPdpPrice();

    var detail = document.querySelector('#product-info .silverchef-price-block .detail-price');
    if (!detail || !window.MutationObserver) return;

    var queued = false;
    var observer = new MutationObserver(function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        enhanceMainPdpPrice();
      });
    });

    observer.observe(detail, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', function () {
    window.setTimeout(function () {
      removeMainPdpIncGst();
      enhanceMainPdpPrice();
    }, 0);
  });
}());
